export default __webpack_public_path__ + "static/pool-5c969804662ba4e429340118a5bef0d5.jpg";